import { createPortal } from 'react-dom';

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '~/components/ui/toast';
import { useIsClient } from '~/hooks/useIsClient';
import { useToast } from '~/hooks/useToast';

export function Toaster() {
  const { toasts } = useToast();
  const mounted = useIsClient();

  if (!mounted) {
    return null;
  }

  return createPortal(
    <div className="fixed right-0 bottom-0 z-[100]">
      <ToastProvider>
        {toasts.map(function ({ id, title, description, action, ...props }) {
          return (
            <Toast key={id} {...props}>
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && <ToastDescription>{description}</ToastDescription>}
              </div>
              {action}
              <ToastClose />
            </Toast>
          );
        })}
        <ToastViewport />
      </ToastProvider>
    </div>,
    document.body
  );
}
